<template>
  <div>
    <div class="carroselCtn">
      <div class="StatementOnAccount">
        <label
          v-for="item in tabsManual"
          :key="item.text"
          class="StatementOnAccountItem"
          :class="{ active: selectedTabLabel === item.name }"
          @click="storeLabelTabName(item.name)"
        >
          {{ item.text }} <br />
        </label>
      </div>
    </div>

    <div v-if="selectedTabLabel === 'ICMS'" class="contentManual">
      <div class="scrollIssqn">
        <div class="rowContent">
          <div class="selectPlus" style="width: 15%">
            <label class="fixedSelect2">Tipo de Tributação</label>
            <b-form-select
              class="borderInput shadow-none"
              v-model="infoFiscal.icms.tipo_tributacao"
              :options="tributacao"
              value-field="value"
              text-field="text"
            >
            </b-form-select>
          </div>
          <div class="input-group" style="width: 10%">
            <input
              required
              class="input borderInput"
              v-model="infoFiscal.icms.codigo_cfop"
            />
            <label class="user-label"> Código CFOP </label>
          </div>

          <div class="selectPlus" style="width: 60%">
            <label class="fixedSelect2">Situação tributária</label>
            <b-form-select
              class="borderInput shadow-none"
              v-model="infoFiscal.icms.situacao_tributaria"
              :options="taxForSelectBoxes.icms.situacao_tributaria"
              value-field="value"
              text-field="text"
            >
            </b-form-select>
          </div>

          <div
            class="selectPlus"
            style="width: 20%"
            v-if="handleShowICMSInputs.industria"
          >
            <label class="fixedSelect2">Indústria</label>
            <b-form-select
              class="borderInput shadow-none"
              v-model="infoFiscal.icms.industria"
              :options="choices"
              value-field="value"
              text-field="text"
            >
            </b-form-select>
          </div>
        </div>

        <div
          class="rowContent"
          style="gap: 20px; margin-bottom: 20px; flex-wrap: wrap"
        >
          <div
            class="input-group"
            style="width: 15%; min-width: 150px"
            v-if="handleShowICMSInputs.aliquota"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.aliquota"
            />
            <label class="user-label">Alíquota ICMS %</label>
          </div>

          <div
            class="input-group"
            style="width: 15%; min-width: 150px"
            v-if="handleShowICMSInputs.aliquota_fcp"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.aliquota_fcp"
            />
            <label class="user-label">Alíquota FCP %</label>
          </div>

          <div
            class="input-group"
            style="width: 15%; min-width: 150px"
            v-if="handleShowICMSInputs.aliquota_interestadual"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.aliquota_interestadual"
            />
            <label class="user-label">Alíq. Interestadual %</label>
          </div>

          <div
            class="input-group"
            style="width: 15%; min-width: 150px"
            v-if="handleShowICMSInputs.aliquota_importacao"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.aliquota_importacao"
            />
            <label class="user-label">Alíq. Importação %</label>
          </div>

          <div
            class="input-group"
            style="width: 15%; min-width: 150px"
            v-if="handleShowICMSInputs.majoracao"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.majoracao"
            />
            <label class="user-label">Majoração %</label>
          </div>

          <div
            class="input-group"
            style="width: 20%"
            v-if="handleShowICMSInputs.bc_icms"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.bc_icms"
            />
            <label class="user-label">BC ICMS</label>
          </div>

          <div
            class="input-group"
            style="width: 30%"
            v-if="handleShowICMSInputs.aliquota_reducao"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.aliquota_reducao"
            />
            <label class="user-label"
              >Alíquota da redução da base de cálculo ICMS* %</label
            >
          </div>

          <div
            class="input-group"
            style="width: 20%"
            v-if="handleShowICMSInputs.aliquota_diferimento"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.aliquota_diferimento"
            />
            <label class="user-label">Alíq. Diferimento %</label>
          </div>

          <div
            class="input-group"
            style="width: 20%"
            v-if="handleShowICMSInputs.aliquota_diferimento_fcp"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.aliquota_diferimento_fcp"
            />
            <label class="user-label">Diferimento FCP %</label>
          </div>

          <div
            class="selectPlus"
            style="width: 20%"
            v-if="handleShowICMSInputs.difal_antecipacao"
          >
            <label class="fixedSelect2">Difal Antecipação</label>
            <b-form-select
              class="borderInput shadow-none"
              v-model="infoFiscal.icms.difal_antecipacao"
              :options="[
                { value: true, text: 'Sim' },
                { value: false, text: 'Não' },
              ]"
            ></b-form-select>
          </div>

          <div
            class="input-group"
            style="width: 20%"
            v-if="handleShowICMSInputs.bc_icms_st"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.bc_icms_st"
            />
            <label class="user-label">BC ICMS ST</label>
          </div>

          <div
            class="input-group"
            style="width: 15%; min-width: 150px"
            v-if="handleShowICMSInputs.aliquota_st"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.aliquota_st"
            />
            <label class="user-label">Alíquota ICMS-ST %</label>
          </div>

          <div
            class="input-group"
            style="width: 15%; min-width: 150px"
            v-if="handleShowICMSInputs.aliquota_mva"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.aliquota_mva"
            />
            <label class="user-label">MVA/IVA Original %</label>
          </div>

          <div
            class="input-group"
            style="width: 30%"
            v-if="handleShowICMSInputs.aliquota_reducao_st"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.aliquota_reducao_st"
            />
            <label class="user-label"
              >Alíquota da redução da base de cálculo ICMS-ST* %</label
            >
          </div>

          <div
            class="input-group"
            style="width: 15%; min-width: 150px"
            v-if="handleShowICMSInputs.aliquota_fcp_st"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.aliquota_fcp_st"
            />
            <label class="user-label">FCP ST %</label>
          </div>

          <div
            class="input-group"
            style="width: 20%"
            v-if="handleShowICMSInputs.bc_st_retido"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.bc_st_retido"
            />
            <label class="user-label">BC ST Retido</label>
          </div>

          <div
            class="input-group"
            style="width: 15%; min-width: 150px"
            v-if="handleShowICMSInputs.valor_st_retido"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.valor_st_retido"
            />
            <label class="user-label">Valor ST Retido</label>
          </div>

          <div
            class="input-group"
            style="width: 21%"
            v-if="handleShowICMSInputs.aliquota_bc_efetivo"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.aliquota_bc_efetivo"
            />
            <label class="user-label">BC Efetiva %</label>
          </div>

          <div
            class="input-group"
            style="width: 15%; min-width: 150px"
            v-if="handleShowICMSInputs.aliquota_icms_efetivo"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.aliquota_icms_efetivo"
            />
            <label class="user-label">Alíq. ICMS Efetiva %</label>
          </div>

          <div
            class="input-group"
            style="width: 15%; min-width: 150px"
            v-if="handleShowICMSInputs.valor_icms_substituto"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.valor_icms_substituto"
            />
            <label class="user-label">ICMS Substituto</label>
          </div>

          <div
            class="input-group"
            style="width: 15%; min-width: 150px"
            v-if="handleShowICMSInputs.aliquota_fcp_retido"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.aliquota_fcp_retido"
            />
            <label class="user-label">Alíq. FCP Retido %</label>
          </div>

          <div
            class="input-group"
            style="width: 20%; min-width: 150px"
            v-if="handleShowICMSInputs.valor_fcp_retido"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.valor_fcp_retido"
            />
            <label class="user-label">Valor FCP Retido</label>
          </div>

          <div
            class="input-group"
            style="width: 15%; min-width: 150px"
            v-if="handleShowICMSInputs.aliquota_credito"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.aliquota_credito"
            />
            <label class="user-label">Alíq. Crédito %</label>
          </div>

          <div
            class="input-group"
            style="width: 25%"
            v-if="handleShowICMSInputs.percentual_reducao"
          >
            <input
              class="input borderInput"
              v-model="infoFiscal.icms.percentual_reducao"
            />
            <label class="user-label">Percentual Redução %</label>
          </div>
        </div>

        <div
          class="input-group"
          style="width: 25%"
          v-if="handleShowICMSInputs.pauta_fiscal"
        >
          <input
            class="input borderInput"
            v-model="infoFiscal.icms.pauta_fiscal"
          />
          <label class="user-label">Pauta Fiscal</label>
        </div>

        <div
          class="input-group"
          style="width: 25%"
          v-if="handleShowICMSInputs.quantidade_bc"
        >
          <input
            class="input borderInput"
            v-model="infoFiscal.icms.quantidade_bc"
          />
          <label class="user-label">Qtde Base Cálculo</label>
        </div>

        <div
          class="input-group"
          style="width: 25%"
          v-if="handleShowICMSInputs.quantidade_retencao"
        >
          <input
            class="input borderInput"
            v-model="infoFiscal.icms.quantidade_retencao"
          />
          <label class="user-label">Qtde Retenção</label>
        </div>

        <div
          class="input-group"
          style="width: 25%"
          v-if="handleShowICMSInputs.aliquota_retencao"
        >
          <input
            class="input borderInput"
            v-model="infoFiscal.icms.aliquota_retencao"
          />
          <label class="user-label">Alíq. Retenção</label>
        </div>

        <div
          class="input-group"
          style="width: 25%"
          v-if="handleShowICMSInputs.bc_st_dest"
        >
          <input
            class="input borderInput"
            v-model="infoFiscal.icms.bc_st_dest"
          />
          <label class="user-label">BC ST Destino</label>
        </div>

        <div
          class="input-group"
          style="width: 25%"
          v-if="handleShowICMSInputs.valor_st_dest"
        >
          <input
            class="input borderInput"
            v-model="infoFiscal.icms.valor_st_dest"
          />
          <label class="user-label">Valor ST Destino</label>
        </div>

        <div
          class="selectPlus"
          style="width: 25%"
          v-if="handleShowICMSInputs.motivo_desoneracao_st"
        >
          <label class="fixedSelect2">Motivo Desoneração ST</label>
          <b-form-select
            class="borderInput shadow-none"
            v-model="infoFiscal.icms.motivo_desoneracao_st"
            :options="choices"
          ></b-form-select>
        </div>

        <div
          class="selectPlus"
          style="width: 25%"
          v-if="handleShowICMSInputs.motivo_reducao"
        >
          <label class="fixedSelect2">Motivo Redução</label>
          <b-form-select
            class="borderInput shadow-none"
            v-model="infoFiscal.icms.motivo_reducao"
            :options="choices"
          ></b-form-select>
        </div>

        <div style="padding: 0 1rem">
          <div
            class="rowContent"
            style="
              gap: 10px;
              margin-bottom: 20px;
              border: 1px dashed #ccc;
              padding: 10px;
              border-radius: 8px;
              flex-direction: column;
            "
          >
            <div
              style="width: 100%; display: flex; justify-content: space-between"
            >
              <span style="font-size: 12px; font-weight: bold; color: #666"
                >CRÉDITO PRESUMIDO</span
              >

              <label class="custom-checkbox" style="margin: 0">
                <input
                  name="dummy"
                  type="checkbox"
                   v-model="localFlags.enableCreditoPresumido"
                  @change="
                    changeFlags('enableCreditoPresumido', $event.target.checked)
                  "
                />
                <span class="checkmark"></span>
                Informar crédito presumido ?
              </label>
            </div>

            <div
              style="display: flex; width: 100%; gap: 1rem; margin-top: 10px"
               v-if="localFlags.enableCreditoPresumido"
            >
              <div
                class="input-group"
                style="width: 40%"
                v-if="handleShowICMSInputs.credito_presumido"
              >
                <input
                  class="input borderInput"
                  v-model="
                    infoFiscal.icms.credito_presumido.codigo_beneficio_fiscal
                  "
                />
                <label class="user-label">Cód. Benefício Fiscal</label>
              </div>

              <div
                class="input-group"
                style="width: 30%"
                v-if="handleShowICMSInputs.credito_presumido"
              >
                <input
                  class="input borderInput"
                  v-model="infoFiscal.icms.credito_presumido.aliquota"
                />
                <label class="user-label">Alíquota Créd. Pres. %</label>
              </div>

              <div
                class="input-group"
                style="width: 30%"
                v-if="handleShowICMSInputs.credito_presumido"
              >
                <input
                  class="input borderInput"
                  v-model="infoFiscal.icms.credito_presumido.valor"
                />
                <label class="user-label">Valor Créd. Presumido</label>
              </div>
            </div>
          </div>
        </div>

        <div
          class="rowContent"
          style="gap: 10px"
          v-if="handleShowICMSInputs.deducao_desoneracao"
        >
          <div class="selectPlus" style="width: 50%">
            <label class="fixedSelect2">Dedução Desoneração</label>
            <b-form-select
              class="borderInput shadow-none"
              v-model="infoFiscal.icms.deducao_desoneracao"
              :options="choices"
            ></b-form-select>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="selectedTabLabel === 'ISSQN'"
      class="contentManual"
      style="height: auto"
    >
      <label class="custom-checkbox" style="margin: 0; padding: 0 1rem">
        <input
          name="dummy"
          type="checkbox"
           v-model="localFlags.enableIssqn"
          @change="changeFlags('enableIssqn', $event.target.checked)"
        />
        <span class="checkmark"></span>
        Informar ISSQN ?
      </label>

       <div class="scrollIssqn" v-if="localFlags.enableIssqn">
        <div class="rowContent" style="gap: 10px; margin-bottom: 20px">
          <div class="input-group" style="width: 25%">
            <input
              class="input borderInput"
              v-model="infoFiscal.issqn.codigo_cfop"
            />
            <label class="user-label">Cód. CFOP *</label>
          </div>

          <div class="selectPlus" style="width: 25%">
            <label class="fixedSelect2">Exigibilidade *</label>
            <b-form-select
              class="borderInput shadow-none"
              v-model="infoFiscal.issqn.exigibilidade"
              :options="taxForSelectBoxes.issqn.exigibilidade"
            ></b-form-select>
          </div>

          <div class="input-group" style="width: 25%">
            <input
              class="input borderInput"
              v-model="infoFiscal.issqn.item_servico"
            />
            <label class="user-label">Item do Serviço *</label>
          </div>

          <div class="selectPlus" style="width: 25%">
            <label class="fixedSelect2">Incentivo Fiscal *</label>
            <b-form-select
              class="borderInput shadow-none"
              v-model="infoFiscal.issqn.incentivo_fiscal"
              :options="[
                { value: 1, text: 'Sim' },
                { value: 2, text: 'Não' },
              ]"
            ></b-form-select>
          </div>
        </div>

        <div class="rowContent" style="gap: 10px; margin-bottom: 20px">
          <div class="input-group" style="width: 20%">
            <input
              required
              class="input borderInput"
              v-model="infoFiscal.issqn.aliquota"
            />
            <label class="user-label">Alíquota %</label>
          </div>
          <div class="input-group" style="width: 20%">
            <input
              class="input borderInput"
              v-model="infoFiscal.issqn.deducao"
            />
            <label class="user-label">Dedução</label>
          </div>
          <div class="input-group" style="width: 20%">
            <input
              class="input borderInput"
              v-model="infoFiscal.issqn.retencoes"
            />
            <label class="user-label">Retenções</label>
          </div>
          <div class="input-group" style="width: 20%">
            <input
              class="input borderInput"
              v-model="infoFiscal.issqn.iss_retido"
            />
            <label class="user-label">ISS Retido</label>
          </div>
          <div class="input-group" style="width: 20%">
            <input
              class="input borderInput"
              v-model="infoFiscal.issqn.desconto_incondicionado"
            />
            <label class="user-label">Desc. Incondicionado</label>
          </div>
        </div>

        <div class="rowContent" style="gap: 10px">
          <div class="input-group" style="width: 25%">
            <input
              class="input borderInput"
              v-model="infoFiscal.issqn.municipio"
            />
            <label class="user-label">Município</label>
          </div>

          <div class="input-group" style="width: 25%">
            <input
              class="input borderInput"
              v-model="infoFiscal.issqn.codigo_servico"
            />
            <label class="user-label">Código Serviço</label>
          </div>

          <div class="input-group" style="width: 25%">
            <input
              class="input borderInput"
              v-model="infoFiscal.issqn.processo"
            />
            <label class="user-label">Processo</label>
          </div>

          <div class="input-group" style="width: 25%">
            <input
              class="input borderInput"
              v-model="infoFiscal.issqn.desconto_condicionado"
            />
            <label class="user-label">Desc. Condicionado</label>
          </div>
        </div>
      </div>
    </div>

    <div v-if="selectedTabLabel === 'COFINS'" class="contentManual">
      <div class="scrollIssqn">
        <div class="rowContent" style="gap: 10px">
          <div class="selectPlus" style="width: 40%">
            <label class="fixedSelect2">Situação Tributária *</label>
            <b-form-select
              class="borderInput shadow-none"
              v-model="infoFiscal.cofins.situacao_tributaria"
              :options="taxForSelectBoxes.cofins.situacao_tributaria"
            ></b-form-select>
          </div>
          <div class="input-group" style="width: 20%">
            <input
              required
              class="input borderInput"
              v-model="infoFiscal.cofins.aliquota"
            />
            <label class="user-label">Alíquota %</label>
          </div>
          <div class="input-group" style="width: 20%">
            <input
              class="input borderInput"
              v-model="infoFiscal.cofins.bc_cofins"
            />
            <label class="user-label">Base de Cálculo</label>
          </div>
          <div class="input-group" style="width: 20%">
            <input
              class="input borderInput"
              v-model="infoFiscal.cofins.majoracao"
            />
            <label class="user-label">Majoração %</label>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectedTabLabel === 'PIS'" class="contentManual">
      <div class="scrollIssqn">
        <div class="rowContent" style="gap: 10px">
          <div class="selectPlus" style="width: 40%">
            <label class="fixedSelect2">Situação Tributária *</label>
            <b-form-select
              class="borderInput shadow-none"
              v-model="infoFiscal.pis.situacao_tributaria"
              :options="taxForSelectBoxes.pis.situacao_tributaria"
            ></b-form-select>
          </div>
          <div class="input-group" style="width: 20%">
            <input
              required
              class="input borderInput"
              v-model="infoFiscal.pis.aliquota"
            />
            <label class="user-label">Alíquota %</label>
          </div>
          <div class="input-group" style="width: 20%">
            <input class="input borderInput" v-model="infoFiscal.pis.bc_pis" />
            <label class="user-label">Base de Cálculo</label>
          </div>
          <div class="input-group" style="width: 20%">
            <input
              class="input borderInput"
              v-model="infoFiscal.pis.majoracao"
            />
            <label class="user-label">Majoração %</label>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectedTabLabel === 'IPI'" class="contentManual">
      <div class="scrollIssqn">
        <div class="rowContent" style="gap: 10px; margin-bottom: 20px">
          <div class="selectPlus" style="width: 50%">
            <label class="fixedSelect2">Situação Tributária *</label>
            <b-form-select
              class="borderInput shadow-none"
              v-model="infoFiscal.ipi.situacao_tributaria"
              :options="taxForSelectBoxes.ipi.situacao_tributaria"
            ></b-form-select>
          </div>

          <div class="input-group" style="width: 30%">
            <input
              required
              class="input borderInput"
              v-model="infoFiscal.ipi.codigo_enquadramento"
            />
            <label class="fixedSelect2">Cód. Enquadramento *</label>
          </div>

          <div class="input-group" style="width: 20%">
            <input
              required
              class="input borderInput"
              v-model="infoFiscal.ipi.aliquota"
            />
            <label class="user-label">Alíquota %</label>
          </div>
        </div>

        <div class="rowContent" style="gap: 10px; margin-bottom: 20px">
          <div class="input-group" style="width: 25%">
            <input
              class="input borderInput"
              v-model="infoFiscal.ipi.percentual_devolvido"
            />
            <label class="user-label">% Devolvido</label>
          </div>
          <div class="input-group" style="width: 25%">
            <input
              class="input borderInput"
              v-model="infoFiscal.ipi.ipi_devolvido"
            />
            <label class="user-label">Valor IPI Devolvido</label>
          </div>
          <div class="input-group" style="width: 25%">
            <input class="input borderInput" v-model="infoFiscal.ipi.bc_ipi" />

            <label class="user-label">BC IPI</label>
          </div>
        </div>

        <div class="rowContent" style="gap: 10px">
          <div class="input-group" style="width: 25%">
            <input
              class="input borderInput"
              v-model="infoFiscal.ipi.codigo_selo"
            />

            <label class="user-label">Código do Selo</label>
          </div>

          <div class="input-group" style="width: 50%">
            <input
              class="input borderInput"
              v-model="infoFiscal.ipi.qtd_selo"
            />
            <label class="user-label">Quantidade de Selo</label>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectedTabLabel === 'IBS_CBS'" class="contentManual">
      <div class="scrollIssqn">
        <div class="rowContent" style="padding: 15px 0 !important">
          <div class="selectPlus">
            <label class="fixedSelect2">Tipo pessoa</label>
            <b-form-select
              class="borderInput shadow-none"
              v-model="infoFiscal.ibs_cbs.tipo_pessoa"
              :options="taxForSelectBoxes.ibs_cbs.tipo_pessoa"
              value-field="value"
              text-field="text"
            >
            </b-form-select>
          </div>
          <div class="selectPlus">
            <label class="fixedSelect2">Cenário</label>
            <b-form-select
              class="borderInput shadow-none"
              v-model="infoFiscal.ibs_cbs.cenario"
              :options="taxForSelectBoxes.ibs_cbs.cenario"
              value-field="value"
              text-field="text"
            >
            </b-form-select>
          </div>
          <div class="selectPlus">
            <label class="fixedSelect2">Situação tributária</label>
            <b-form-select
              class="borderInput shadow-none"
              v-model="infoFiscal.ibs_cbs.situacao_tributaria"
              :options="taxForSelectBoxes.ibs_cbs.situacao_tributaria"
              value-field="value"
              text-field="text"
            >
            </b-form-select>
          </div>
        </div>
        <div class="rowContent" style="padding: 15px 0 !important">
          <div class="selectPlus" style="width: 100% !important">
            <label class="fixedSelect2">Classificação Tributária</label>
            <b-form-select
              class="borderInput shadow-none"
              v-model="infoFiscal.ibs_cbs.classificacao_tributaria"
              :options="opcoesClassificacao"
              value-field="value"
              text-field="text"
            >
            </b-form-select>
          </div>
        </div>
        <div
          class="rowContentInit"
          v-if="infoFiscal.ibs_cbs.situacao_tributaria === '550'"
        >
          <div class="selectPlus">
            <label class="fixedSelect2"
              >Situação Tributária (Regime Regular)
            </label>
            <b-form-select
              class="borderInput shadow-none"
              v-model="infoFiscal.ibs_cbs.situacao_tributaria_regular"
              :options="taxForSelectBoxes.ibs_cbs.situacao_tributaria"
              value-field="value"
              text-field="text"
            >
            </b-form-select>
          </div>
          <div class="selectPlus" style="width: 100% !important">
            <label class="fixedSelect2"
              >Classificação Tributária (Regime Regular)</label
            >
            <b-form-select
              class="borderInput shadow-none"
              v-model="infoFiscal.ibs_cbs.classificacao_tributaria_regular"
              :options="opcoesClassificacaoRegular"
              value-field="value"
              text-field="text"
            >
            </b-form-select>
          </div>
        </div>
        <div
          class="rowContentInit"
          v-if="infoFiscal.ibs_cbs.situacao_tributaria === '510'"
        >
          <div class="input-group-init">
            <input
              required
              class="input borderInput"
              v-model="infoFiscal.ibs_cbs.ibs_estadual.aliquota_diferimento"
            />
            <label class="user-label" style="left: -10px !important">
              IBS Estadual - Alíquota de Diferimento %
            </label>
          </div>
          <div class="input-group-init">
            <input
              required
              class="input borderInput"
              v-model="infoFiscal.ibs_cbs.ibs_municipal.aliquota_diferimento"
            />
            <label class="user-label" style="left: -10px !important">
              IBS Municipal - Alíquota de Diferimento %
            </label>
          </div>
          <div class="input-group-init">
            <input
              required
              class="input borderInput"
              v-model="infoFiscal.ibs_cbs.cbs.aliquota_diferimento"
            />
            <label class="user-label" style="left: -10px !important">
              CBS - Alíquota de Diferimento %
            </label>
          </div>
        </div>
        <div
          class="rowContentInit"
          v-if="
            (infoFiscal.ibs_cbs.situacao_tributaria === '510' &&
              infoFiscal.ibs_cbs.classificacao_tributaria === '510002') ||
            (infoFiscal.ibs_cbs.situacao_tributaria === '550' &&
              infoFiscal.ibs_cbs.classificacao_tributaria === '550001')
          "
        >
          <div class="selectPlus" style="width: 40% !important">
            <label class="fixedSelect2"
              >Classificação do Crédito Presumido</label
            >
            <b-form-select
              class="borderInput shadow-none"
              v-model="infoFiscal.ibs_cbs.credito_presumido.classificacao"
              :options="taxForSelectBoxes.ibs_cbs.credito_presumido"
              value-field="value"
              text-field="text"
            >
            </b-form-select>
          </div>
          <div class="input-group-init">
            <input
              required
              class="input borderInput"
              v-model="infoFiscal.ibs_cbs.credito_presumido.aliquota_ibs"
            />
            <label class="user-label" style="left: -10px !important">
              IBS - Alíquota do Crédito Presumido %
            </label>
          </div>
          <div class="input-group-init">
            <input
              required
              class="input borderInput"
              v-model="infoFiscal.ibs_cbs.credito_presumido.aliquota_cbs"
            />
            <label class="user-label" style="left: -10px !important">
              CBS - Alíquota do Crédito Presumido %
            </label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  initialStateTaxForSelectBoxes,
  initialStateInfoFiscal,
} from "../../initialStates/infoFiscal";
import { TOGGLE_INPUTS_ICMS } from "../../initialStates/manulTaxes";

export default {
  props: {
    flags: {
      type: Object,
      default: () => ({}),
    },
    impostoManual: { type: Object, default: null },
    itemMode: { type: Boolean, default: false },
  },
  data() {
    return {
      infoFiscal: JSON.parse(JSON.stringify(this.impostoManual || initialStateInfoFiscal.imposto_manual)),
      localFlags: JSON.parse(JSON.stringify(this.flags || {})),
      taxForSelectBoxes: JSON.parse(JSON.stringify(initialStateTaxForSelectBoxes)),
      createdNewRef: false,
      manualTax: false,
      refsFiscais: [],
      tabsManual: [
        { name: "ICMS", text: "ICMS" },
        { name: "IPI", text: "IPI" },
        { name: "PIS", text: "PIS" },
        { name: "COFINS", text: "COFINS" },
        { name: "ISSQN", text: "ISSQN" },
        { name: "IBS_CBS", text: "IBS/CBS" },
      ],
      tributacao: [
        { value: "simples_nacional", text: "Simples" },
        { value: "tributacao_normal", text: "Normal" },
      ],
      choices: [
        { value: 0, text: "Não" },
        { value: 1, text: "Sim" },
      ],
      motivoDesoneracao: [
        { value: null, text: "--" },
        { value: "1", text: "1 - Táxi" },
        { value: "2", text: "3 - Uso na agropecuária" },
        { value: "3", text: "4 - Frotista/Locadora" },
        { value: "4", text: "5 - Diplomático/Consular" },
        {
          value: "5",
          text: "6 - Utilitários e Motocicletas da Amazônia Ocidental e Áreas de Livre Comércio",
        },
        { value: "6", text: "7 - SUFRAMA" },
        { value: "7", text: "8 - Venda a Órgão Público" },
        { value: "7", text: "9 - Outros" },
        { value: "7", text: "10 - Deficiente Condutor (Convênio ICMS 38/12)" },
        {
          value: "7",
          text: "11 - Deficiente Não Condutor (Convênio ICMS 38/12)",
        },
        {
          value: "7",
          text: "12 - Órgão de fomento e desenvolvimento agropecuário",
        },
        { value: "7", text: "16 - Olimpíadas Rio 2016" },
        { value: "7", text: "90 - Solicitado pelo Fisco " },
      ],
      trib: "Simples",
      tabSelected: 0,
      selectedTabLabel: "ICMS",
    };
  },
  methods: {
    storeLabelTabName(labelName) {
      this.selectedTabLabel = labelName;
    },
    changeFlags(key, value) {
      this.$emit("updateFlags", { ...this.localFlags, [key]: value });
    },
  },
  watch: {
    flags: { deep: true, handler(value) { this.localFlags = JSON.parse(JSON.stringify(value || {})); } },
    impostoManual: { deep: true, handler(value) {
      if (value && JSON.stringify(value) !== JSON.stringify(this.infoFiscal)) {
        this.infoFiscal = JSON.parse(JSON.stringify(value));
      }
    } },
    infoFiscal: { deep: true, handler(value) {
      this.$emit("update:impostoManual", JSON.parse(JSON.stringify(value)));
    } },
    manualTax(newValue) {
      const index = this.tabs.findIndex((tab) => tab.name === "manualTax");

      if (newValue && index === -1) {
        this.tabs.push({ name: "manualTax", text: "Impostos Manuais" });
      } else if (!newValue && index !== -1) {
        this.tabs.splice(index, 1);
      }
    },
    opcoesClassificacao(novasOpcoes) {
      if (novasOpcoes && novasOpcoes.length > 0) {
        this.infoFiscal.ibs_cbs.classificacao_tributaria = novasOpcoes.value;
      } else {
        this.infoFiscal.ibs_cbs.classificacao_tributaria = null;
      }
    },
    opcoesClassificacaoRegular(novasOpcoes) {
      if (novasOpcoes && novasOpcoes.length > 0) {
        this.infoFiscal.ibs_cbs.classificacao_tributaria_regular =
          novasOpcoes.value;
      } else {
        this.infoFiscal.ibs_cbs.classificacao_tributaria_regular = null;
      }
    },
  },
  computed: {
    opcoesClassificacao() {
      const situacao = this.infoFiscal.ibs_cbs.situacao_tributaria;
      const chaveOpcoes = `sit${situacao}`;
      return this.taxForSelectBoxes.ibs_cbs[chaveOpcoes] || [];
    },
    opcoesClassificacaoRegular() {
      const situacao = this.infoFiscal.ibs_cbs.situacao_tributaria_regular;
      const chaveOpcoes = `sit${situacao}`;
      return this.taxForSelectBoxes.ibs_cbs[chaveOpcoes] || [];
    },
    handleShowICMSInputs() {
      const defaultItems = {
        valor_icms_substituto: false,
        aliquota_credito: false,
        pauta_fiscal: false,
        quantidade_retencao: false, //OBRIGATORIO SEMPRE
        aliquota_retencao: false, //OBRIGATORIO SEMPRE
        percentual_reducao: false,
        motivo_reducao: false,
        aliquota_diferimento_fcp: false,
        aliquota_diferimento: false,
        aliquota_st: false,
        aliquota_fcp_st: false,
        aliquota_mva: false, //OBRIGATORIO SEMPRE
        aliquota_reducao: false, //OBRIGATORIO SEMPRE
        aliquota_reducao_st: false,
        motivo_desoneracao: false,
        motivo_desoneracao_st: false,
        deducao_desoneracao: false,
        quantidade_bc: false,
        bc_st_retido: false,
        aliquota_st_retido: false,
        valor_st_retido: false,
        bc_st_dest: false,
        valor_st_dest: false,
        valor_fcp_retido: false,
        aliquota_fcp_retido: false,
        aliquota_bc_efetivo: false,
        aliquota_icms_efetivo: false,
      };

      return {
        ...defaultItems,
        ...TOGGLE_INPUTS_ICMS[Number(this.infoFiscal.icms.situacao_tributaria)],
      };
    },
  },
};
</script>
<style scoped>
.contentManual {
  padding-top: 20px;
  margin-top: 2px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  height: 50vh;
  background: #fcfcfc;
  border: 1px solid #d1d1d1;
  border-radius: 5px;
  overflow: scroll;
}

.carroselCtn {
  display: flex;
  gap: 10px;
}

.StatementOnAccount {
  display: flex;
  align-items: flex-end;
  height: 40px;
  padding: 0 0 0 10px;
  width: 100%;
  gap: 3px;
  transition: transform 0.5s ease-in-out;
}
.StatementOnAccount ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
.StatementOnAccount::-webkit-scrollbar-track {
  background: white;
}

.StatementOnAccount::-webkit-scrollbar-thumb {
  background-color: transparent;
  border-radius: 2px;
}

.StatementOnAccountItem {
  height: 30px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 0 20px;
  background: #f1f9ff;
  color: #000000;
  font-size: 13px;
  margin: 0 !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  text-transform: capitalize;
  transition: background-color 0.3s ease, color 0.3s ease,
    border-bottom 0.3s ease, height 0.3s ease, padding-bottom 0.3s ease,
    transform 0.3s ease;
}

.StatementOnAccountItem p {
  font-weight: 600;
}

.StatementOnAccountItem.active {
  background-color: rgb(0 58 93);
  color: white;
  border-radius: 5px 5px 0 0;
}

.StatementOnAccountItem:hover {
  background-color: rgb(0 58 93);
  color: white;
}

.StatementOnAccountItem:focus {
  background: rgb(0 58 93);
  color: white;
  border-bottom: 3px solid #ff0040 !important;
  outline: none;
}

.custom-checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
  font-size: 11px;
  color: #333;
  transition: color 0.3s;
}

.custom-checkbox input[type="checkbox"] {
  display: none;
}

.custom-checkbox .checkmark {
  width: 14px;
  height: 14px;
  border: 2px solid #333;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
  transition: background-color 0.3s, border-color 0.3s, transform 0.3s;
  transform-style: preserve-3d;
}

.custom-checkbox .checkmark::before {
  content: "\2713";
  font-size: 12px;
  color: transparent;
  transition: color 0.3s, transform 0.3s;
}

.custom-checkbox input[type="checkbox"]:checked + .checkmark {
  background-color: #00395d;
  border-color: #333;
  transform: scale(1.1) rotateZ(360deg) rotateY(360deg);
}

.custom-checkbox input[type="checkbox"]:checked + .checkmark::before {
  color: #f0f0f0;
}

.custom-checkbox:hover {
  color: #666;
}

.custom-checkbox:hover .checkmark {
  border-color: #666;
  background-color: #f0f0f0;
  transform: scale(1.05);
}

.custom-checkbox input[type="checkbox"]:focus + .checkmark {
  box-shadow: 0 0 3px 2px rgba(0, 0, 0, 0.2);
  outline: none;
}

.custom-checkbox .checkmark,
.custom-checkbox input[type="checkbox"]:checked + .checkmark {
  transition: background-color 1.3s, border-color 1.3s, color 1.3s,
    transform 0.3s;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 15px;
  justify-content: flex-start;
  gap: 10px;
}
.rowContentInit {
  position: relative;
  display: flex;
  width: 100%;
  padding: 15px 0;
  justify-content: flex-start;
  gap: 10px;
}
.input-group-init {
  width: 25%;
  position: relative;
}

.selectPlus {
  position: relative;
  width: 40%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}
.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 11px;
  font-weight: 600;
  bottom: 23px;
  left: 10px;
  z-index: 2;
  text-transform: capitalize;
  color: #666360;
  background-color: white;
  padding: 0 3px;
}
.user-label {
  position: absolute;
  left: 0px;
  font-size: 12px;
  bottom: 4px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
  font-weight: 600;
}
.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 11px !important;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  background: none;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.borderInput {
  font-size: 13px;
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}
</style>
